module.exports = __webpack_public_path__ + "media/newstyle/images/language-translate-77c1efa673abfd92e42162af895d3280.svg";